var _style, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShieldRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 275.6 491.1",
    style: {
      enableBackground: "new 0 0 275.6 491.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#89898A;}\n\t.st1{fill:#2F2F2F;}\n\t.st2{fill:#848584;}\n\t.st3{fill:#FFD500;stroke:#000000;stroke-miterlimit:10;}\n\t.st4{fill:#A1A1A1;stroke:#000000;stroke-miterlimit:10;}\n\t.st5{fill:#DFDFDF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.8,15.9H13.1v43.6c9.3-1.5,18.5-2.7,27.8-3.2V15.9H40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.1,59.5V164c9.6-1.6,19-3,27.8-7.1V56.3C31.6,56.8,22.3,58,13.1,59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.1,164v327.1h27.8V156.8C32.1,160.9,22.6,162.4,13.1,164z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M230.3,139.9h-220c-2.9,0-5.3-2.4-5.3-5.3V49c0-2.9,2.4-5.3,5.3-5.3h220c1.6,0,3.1,0.7,4.1,1.9l36.1,43.5 c1.6,2,1.6,4.8,0,6.8l-36.1,42.2C233.3,139.3,231.8,139.9,230.3,139.9L230.3,139.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 33.5,
    cy: 66.8,
    r: 6.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 33.5,
    cy: 121,
    r: 6.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M11.1,0H42c0.7,0,1.3,0.6,1.3,1.3v17.3H9.8V1.3C9.8,0.6,10.4,0,11.1,0z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldRight);
export default __webpack_public_path__ + "static/media/shield-right.6258ee4269e2d47c88ba79de8eb66b6a.svg";
export { ForwardRef as ReactComponent };